import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Services from './Services';
import Clintes from './Clintes';
import Billboards from './Billboards';

function App() {
  return (
    <div className="App">



     <div className=' '> 
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='home' element={<Home/>} />
          <Route path='services' element={<Services/>} />
          <Route path='billboards' element={<Billboards/>} />
          <Route path='clintes' element={<Clintes/>} />
        </Routes>
     </div>


    </div>
  );
}

export default App;
